import React from 'react';
import { AIAgentSidebarContent } from './AIAgentSidebarContent';

/**
 * AIAgentSidebarMobile - Clean Architecture
 * 
 * ✅ FIXED: Simplified to use centralized state management
 * 
 * This component is now just a layout wrapper that passes through
 * the onClose prop. All state management is handled by the centralized
 * useAIAgentSidebarState hook in child components.
 */
export const AIAgentSidebarMobile: React.FC<{ onClose?: () => void }> = ({ onClose }) => {
  return (
    <div className="flex flex-col h-full w-full">
      {/* Main content area - now takes full space */}
      <div className="flex-1 flex flex-col min-h-0">
        <AIAgentSidebarContent onClose={onClose} />
      </div>
    </div>
  );
}; 